import React from 'react';
import MainPage from './MainPage';

const Decoration = () => {
  return <MainPage tag='DECORATION' title='DECORATION' url='/decoration'/>;
}

export default Decoration;